import React from 'react';
import classes from './Burger.css';
import BurgerIngridient from './BurgerIngridient/BurgerIngridient';


const burger = (props)=>{
	
	let transformedIngredients = Object.keys(props.ingredients)
	.map(igKey => {
		return [...Array(props.ingredients[igKey])]
		.map((item, index) => {
			return  <BurgerIngridient key={igKey + index} type={igKey}/>
		})
	})
	.reduce((prevValue, currentValue) => {
		// return prevValue.concat(currentValue)
		return [...prevValue, ...currentValue]
	});

	if(transformedIngredients.length < 1){
		transformedIngredients = 'Please start adding ingredients'
	}
	
	return(
		<div className={classes.Burger}>
			<BurgerIngridient type='bread-top'/>
			{transformedIngredients}
			<BurgerIngridient type='bread-bottom'/>
		</div>
	);
};

export default burger;


// WEBPACK FOOTER //
// ./src/components/Burger/Burger.js